import * as loadjs from 'loadjs'
import { LoadJsBundle } from '../enums/LoadJsBundle'
import { domReady } from '../helpers/DOM'
import WebModel from '../models/WebModel'
import { getQueryParam } from '../helpers/getQueryParam'

export const COMSCORE_URL = 'scorecardresearch.com/beacon.js'
export const COMSCORE_C1 = '2'
export const COMSCORE_C2 = '27053452'

export default class ComScore {
  constructor(model: WebModel, private _window: Window = window) {
    if (
      !model.mediavine_comscore ||
      getQueryParam('disableComscore') !== undefined
    ) {
      return
    }

    this._window._comscore = this._window._comscore || []
    this._window._comscore.push({ c1: COMSCORE_C1, c2: COMSCORE_C2 })
    const comscoreScriptUrl = this.getComscoreUrl()

    loadjs(comscoreScriptUrl, LoadJsBundle.comscore)

    if (!model.footer_branding) {
      return
    }

    domReady(() => {
      const footer =
        model.footer_selector &&
        this._window.document.querySelector(model.footer_selector)
      const body = this._window.document.querySelector('body')
      const insertElement = footer || body

      if (!insertElement) {
        // if neither the footer nor body exist, give up inserting branding
        return
      }

      const comscoreSubtext = getComscoreSubtext(model)

      insertElement.insertAdjacentHTML(
        'beforeend',
        `<div id='footer_branding' style='text-align : center; font-size : 11px; margin-top : 10px;'>
            Exclusive Member of ${comscoreSubtext}
          </div>`
      )
    })
  }

  private getComscoreUrl(): string {
    const urlProtocolSubdomain =
      this._window.document.location.protocol === 'https:'
        ? 'https://sb.'
        : 'http://b.'

    return `${urlProtocolSubdomain}${COMSCORE_URL}`
  }
}

export function getComscoreSubtext(model: WebModel): string {
  const topLevelCategorySlug =
    model.topLevelCategory && model.topLevelCategory.slug

  switch (topLevelCategorySlug) {
    case 'food-and-drink':
      return 'Mediavine Food'
    case 'travel':
      return 'Mediavine Travel'
    case 'family-and-parenting':
      return 'Mediavine Family'
    case 'hobbies-and-interests':
      return 'Mediavine Home'
    case 'home-and-garden':
      return 'Mediavine Home'
    case 'personal-finance':
      return 'Mediavine Finance'
    default:
      // Default to food
      return 'Mediavine Food'
  }
}
